import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PAYMENTMODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PaymentMode.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PaymentMode.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const PAYMENTMODE_CONFIG = {
  entityName: 'PaymentMode',
  localizationKey: 'Controlling::Entity.PaymentMode',
  fields: PAYMENTMODE_FIELDS,
  permission: 'ControllingContract.PaymentModes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
